import { useDispatch, useSelector } from "react-redux";
import Bin from "../../../../../images/red_bin.svg";
import { RestaurantCart } from "../../../../../interfaces/Catalogue";
import { updateCart } from "../../../../../store/cart/cartActions";
import OrderDetails from "../../../OrderDetails/OrderDetails";
import "../cartModalStyles.scss";

interface CartElementsProps {
  restaurantCart: RestaurantCart;
  setShowCommandDetails?: (value: boolean) => void;
}

const CartElements = (props: CartElementsProps) => {
  const {
    restaurantCart,
    setShowCommandDetails,
  } = props;
  const { restaurant, categories } = restaurantCart;
  const restaurantId = restaurant?.id;
  const savedCategories = useSelector(
    (state: any) => state.cart.savedCategories
  );
  const dispatch = useDispatch();

  const handleCancel = () => {
    let updatedCategories = { ...savedCategories };
    delete updatedCategories[restaurantId];
    dispatch(updateCart(updatedCategories));
    setShowCommandDetails && setShowCommandDetails(false);
  };

  return (
    <div className="CartElements">
      <div className="CartsElements-listing">
        <div
          className={`menuElement animated animatedFadeInUp fadeInUp isPaimentPage`}
        >
          <OrderDetails
            categories={categories}
            orderType={restaurantCart?.mode || 0}
            canApplyArticleDiscount={false}
            canEditQuantity={true}
            restaurantId={restaurantId}
          />
        </div>

        <div className="cancel-btn">
          <button className="cancel-btn" onClick={handleCancel}>
            <img src={Bin} alt="" />
            Annuler commande
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartElements;
